import APIClient from '@/shared/http/clients/webclient'

const resourceName = 'ws'
const ViaCEP = 'https://viacep.com.br'

const GetCEP = (cep, config = {}) => APIClient.get(`${ViaCEP}/${resourceName}/${cep}/json`, config)

const CepRepository = {
  GetCEP
}

export default CepRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/external/cep.js